import React, { useState } from "react";
import { useParams } from "react-router-dom";
import CoreSpinner from "../../../app/core/components/CoreSpinner/CoreSpinner.jsx";
import { useGetCommercialistaIdQuery } from "../../api/admin/gestisciCommercialistiApi.js";
import FormOperator from "./FormOperator.jsx";
import AssociateTableUser from "../../../app/core/components/CoreAssociateTable/AssociateTableUser.jsx";
import AssociateStudiTable from "../../../app/core/components/CoreAssociateTable/AssociateStudiTable.jsx";
import { useTranslation } from "react-i18next";
import CoreBack from "../../../app/core/components/CoreBack/CoreBack.jsx";
import CoreTabBar from "../../../app/core/components/CoreTabBar/CoreTabBar.jsx";

const SchedaCommercialista = () => {
  const { t } = useTranslation();
  const params = useParams();
  const [selectedTab, setSelectedTab] = useState("user");

  const TABS_OPERATOR = [
    { label: "Clienti", tab: "user" },
    { label: "Studi", tab: "studios" },
  ];

  const { data, isLoading, refetch } = useGetCommercialistaIdQuery(params.id);

  const isValidationOperator = data && data.Data;

  if (isLoading && !isValidationOperator) {
    return <CoreSpinner />;
  }

  return (
    <div className="flex-row">
      <div className="flex items-center w-full ">
        <CoreBack />
        <div className="w-11/12">
          <h2>{`${t("Operator")} ${data?.Data?.name}`}</h2>
        </div>
        <CoreTabBar
          tab={TABS_OPERATOR}
          setSelectedTab={setSelectedTab}
          selectedTab={selectedTab}
        />
      </div>

      <div className="flex space-x-8">
        <div className="w-6/12">
          <FormOperator operatorData={data} />
        </div>

        <div className="w-6/12 ">
          {selectedTab === "user" && (
            <AssociateTableUser
              userData={data?.Data?.associatedUsers}
              adminId={params.id}
            />
          )}
          {selectedTab === "studios" && (
            <AssociateStudiTable
              adminData={data?.Data?.associatedStudios}
              adminId={params.id}
              refetch={refetch}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default SchedaCommercialista;
